export default __webpack_public_path__ + "static/media/apps.44840a7f.svg";